import { Box } from '@mui/material'
import { sharedStarIcon } from '../../assets/index'

export const STAR_BULLET_SIZE = 8

export default function StarBullet({ src = sharedStarIcon, sx = {} }) {
  return (
    <Box
      component="img"
      src={src}
      alt=""
      aria-hidden
      sx={{
        width: STAR_BULLET_SIZE,
        height: STAR_BULLET_SIZE,
        flexShrink: 0,
        display: 'block',
        objectFit: 'contain',
        ...sx,
      }}
    />
  )
}
